import React from 'react';
import Modal from '../../../../components/modal';
import Button from '../../../../components/button/button';
import TextField from '../../../../components/form/text-field';
import FormError from '../../../../components/form/error/error';
import { Desktop, Mobile } from '../../../../app-responsive';
import { customStylesDesktop, customStylesMobile } from '../../../../components/business-case-delete-modal/modal-styles-config';
import './request-callback-modal.css';
import PopupHeader from '../popup-header/popup-header';

const RequestCallBackModalOffline = (props) => {
  const {
    customerContactPhone,
    modalIsOpen,
    onCloseDialogBox,
    onRequestCallback,
    authorableContent,
    callBackRequestCompleted,
    IsCallBackPhoneNumberhasError,
    onBlur,
    onChange,
  } = props;

  const {
    requestCallbackOfflineTitle,
    requestCallbackOfflineText,
    requestCallbackOfflineYesText,
    requestCallbackOfflineFormfields,
    callbackThankYouTitle,
    callbackThankYouText,
  } = authorableContent;

  const {
    placeholder,
    errorText,
  } = requestCallbackOfflineFormfields.callbackNumber;

  const desktopModalStyles = { content: { ...customStylesDesktop.content, width: '50%' } };

  const modalContent = customStyles => (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onCloseDialogBox}
      style={customStyles}
      ariaHideApp={false}
    >
      {callBackRequestCompleted === false &&
        <div className={`request-callback-offline-modal text-center ${IsCallBackPhoneNumberhasError ? 'has-error' : ''}`}>
          <PopupHeader PopTitle={requestCallbackOfflineTitle} PopupText={requestCallbackOfflineText} />
          <div className="row action-block offline-action">
            <TextField
              id="callbackNumber"
              customClass="block-spacer col"
              placeholder={placeholder}
              value={customerContactPhone}
              onChange={onChange}
              onBlur={onBlur}
            />
            <Button
              className="button do-business model-button"
              buttonText={requestCallbackOfflineYesText}
              onClick={onRequestCallback}
              disabled={IsCallBackPhoneNumberhasError || customerContactPhone.length === 0}
            />
          </div>
          {IsCallBackPhoneNumberhasError && <FormError errorText={errorText} />}
        </div>
      }
      {callBackRequestCompleted &&
        <div className="request-callback-offline-modal text-center">
          <PopupHeader PopTitle={callbackThankYouTitle} PopupText={callbackThankYouText} />
        </div>
      }
    </Modal>
  );
  return (
    <React.Fragment>
      <Mobile>
        {modalContent(customStylesMobile)}
      </Mobile>
      <Desktop>
        {modalContent(desktopModalStyles)}
      </Desktop>
    </React.Fragment>
  );
};

export default RequestCallBackModalOffline;
